import React from 'react'
import Manager from '../../public/components/Manager'
import LeaveApplyDetail from './LeaveApplyDetail'
import { doLeaveApplyAction } from '../../business/LeaveApplyAction'

Ext.require('Ext.Toast')

const config = props => {
	return {
		tabs: {
			'申请中': {
				buttons: [
					{ text: '申请...', handler: ({ showDetail, refreshPage }) => showDetail(props => <LeaveApplyDetail {...props} id={0} />) },
				],
				columns: [
					{ _text: '申请编号', minWidth: 250, search: true, },
					{ _text: '假期项目', field: 'OutReason', minWidth: 150, search: true, filter: ['select'], },
					{ _datetime: '开始时间', minWidth: 150, flex: 10, filter: true, align: 'left' },
					{ _datetime: '结束时间', minWidth: 150, flex: 10, filter: true, align: 'left' },
					{ _text: '职务代理人', minWidth: 150, search: true, },
					{ _text: '申请人', minWidth: 150, search: true, },
				],
				onDoubleTap: ({ showDetail, refreshPage }, data) => {
					showDetail(props => <LeaveApplyDetail {...props} id={data.id} />)
				}
			},
			'驳回申请': {
				buttons: [
				],
				columns: [
					{ _text: '申请编号', minWidth: 250, search: true, },
					{ _text: '假期项目', field: 'OutReason', minWidth: 150, search: true, filter: ['select'], },
					{ _datetime: '开始时间', minWidth: 150, flex: 10, filter: true, align: 'left' },
					{ _datetime: '结束时间', minWidth: 150, flex: 10, filter: true, align: 'left' },
					{ _text: '职务代理人', minWidth: 150, search: true, },
					{ _text: '申请人', minWidth: 150, search: true, },
					{ _: 'taskName', field: '_TaskName' }
				],
				onDoubleTap: ({ showDetail, refreshPage }, data) => {
					showDetail(props => <LeaveApplyDetail {...props} id={data.id} taskName={data.taskName} />)
				}
			},
			'签核中': {
				buttons: [
				],
				columns: [
					{ _text: '申请编号', minWidth: 250, search: true, },
					{ _text: '假期项目', field: 'OutReason', minWidth: 150, search: true, filter: ['select'], },
					{ _datetime: '开始时间', minWidth: 150, flex: 10, filter: true, align: 'left' },
					{ _datetime: '结束时间', minWidth: 150, flex: 10, filter: true, align: 'left' },
					{ _text: '职务代理人', minWidth: 150, search: true, },
					{ _text: '申请人', minWidth: 150, search: true, },
					{ _text: '当前操作人', minWidth: 150, search: true, flex: 10, },
					{ _: '状态名称' },
					// {
					//     _button: '驳回', icon: 'reply', ui: 'action decline alt', minWidth: 150, handler: ({ showDetail, refreshPage }, data) => {
					//         doLeaveApplyAction(props.dispatch, '驳回', { id: data.id, action: `${data.状态名称}.驳回`, onSave: refreshPage, showDetail: showDetail })
					//     }
					// },
				],
				onDoubleTap: ({ showDetail, refreshPage }, data) => {
					showDetail(props => <LeaveApplyDetail {...props} id={data.id} readOnly={true} />)
				}
			},
			'已完成': {
				buttons: [
				],
				columns: [
					{ _text: '申请编号', minWidth: 250, search: true, },
					{ _text: '假期项目', field: 'OutReason', minWidth: 150, search: true, filter: ['select'], },
					{ _datetime: '开始时间', minWidth: 150, flex: 10, filter: true, align: 'left' },
					{ _datetime: '结束时间', minWidth: 150, flex: 10, filter: true, align: 'left' },
					{ _text: '职务代理人', minWidth: 150, search: true, },
					{ _text: '申请人', minWidth: 150, search: true, },
				],
				onDoubleTap: ({ showDetail, refreshPage }, data) => {
					showDetail(props => <LeaveApplyDetail {...props} id={data.id} />)
				}
			},
		}
	}
}

export default props => <Manager {...props} config={config} />